import { Component, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { displayPayLink, removeIFrame, initializaDisplayPayLink } from '../../assets/dollarpay.js'

import { Router, ActivatedRoute } from '@angular/router';


import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-receive-component',
  templateUrl: './receive.component.html'
})
export class ReceiveComponent {
  public currentCount = 0;

  public incrementCounter() {
    this.currentCount++;
  }

  source;
  loading: boolean = false;

  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {

    this.source = decodeURI(this.activeRoute.snapshot.params['id']);

    this.fetchVendor();

    initializaDisplayPayLink(this.source)

  }
  vendor;
  lock;
  paymentAlreadyDone: boolean = false;
  paymentCancelled: boolean = false;
  fetchVendor() {

    this.loading = true;
    const request = {
      SessionId: this.source
    }



    this.httpService.post<any>('Store/fetch-session-identifier-details-second-way', request, false).subscribe(
      resp => {
        this.vendor = JSON.parse(resp.message);
        //console.log(this.vendor);

        this.lock = this.vendor.secretLock;

        if (this.vendor.success == 1) { this.start = false; this.paymentAlreadyDone = true; }
        if (this.vendor.cancel == 1) { this.start = false; this.paymentCancelled = true; }

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }

  show() {



    displayPayLink(this.source);




  }






  SecretCode;
  result;

  checkCode() {

    this.loading = true;
    const request = {
      SessionId: this.source,
      Code: this.SecretCode.replace("-", "")
    }



    this.httpService.post<any>('Store/check-session-identifier-secret', request, false).subscribe(
      resp => {
        this.result = JSON.parse(resp.message);

        if (this.result.message == "success") {
          this.lock = 0;

        }
       
        this.SecretCode = "";

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });



  }




  success: boolean = false;
  start: boolean = true;
  transactionId;

  @HostListener('window:message', ['$event'])
  onMessage(event) {

    //console.log(event)
    const data = JSON.parse(event.data);
    //console.log(data.message)

    if (data.message == 'success') {

      this.transactionId = data.transactionId;

      this.start = false;
      this.success = true;
      removeIFrame();


    }



    if (data.message == 'terminated') {
      console.log("termination")
      removeIFrame();


    }

  };


}
